<template>
  <div class="accordion-block">
    <div v-b-toggle="collapse_id" class="accordion-block__header">
      <h2 v-if="heading" class="vb-heading accordion-block__title">{{ title }}</h2>
      <span v-else class="accordion-block__title accordion-block__title--plain">{{ title }}</span>
      <vb-icon
        class="accordion-block__chevron"
        :name="'chevron-down'"
        :size="16"
      />
    </div>
    <b-collapse
      :id="collapse_id"
      class="accordion-block__body"
      :accordion="accordion"
      :visible="visible"
    >
      <slot></slot>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'accordion-block',

  props: {
    title: {
      type: String,
      default: '',
    },
    collapse_id: {
      type: String,
      required: true,
    },
    accordion: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>

  .accordion-block {
    $this: &;

    background-color: $white;
    border-radius: $border-radius-lg;

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: $grid-gutter-width/2;
      padding: $grid-gutter-20;
      cursor: pointer;

      &.not-collapsed {
        #{$this}__chevron {
          transform: rotate(-180deg);
        }
      }
    }

    &__title {
      margin-bottom: 0;

      &--plain {
        font-size: 1rem;
        font-weight: $font-weight-normal;
        text-transform: none;
      }
    }

    &__chevron {
      flex-shrink: 0;
      transition: transform .2s ease-in-out;
    }

    &__body {
      padding: 0 $grid-gutter-20 $grid-gutter-20;

      ::v-deep p:last-child {
        margin-bottom: 0;
      }

      ::v-deep ul:last-child {
        margin-bottom: 0;
      }
    }
  }

</style>
